import { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';
function getIsVisibleOrNear(element, nearDistance) {
    var _element_getBoundingClientRect, _this;
    const rect = (_this = element) === null || _this === void 0 ? void 0 : (_element_getBoundingClientRect = _this.getBoundingClientRect) === null || _element_getBoundingClientRect === void 0 ? void 0 : _element_getBoundingClientRect.call(_this);
    // SSR or not rendered yet
    if (!rect || typeof window === 'undefined') {
        return true;
    }
    const topOffset = rect.y - window.innerHeight;
    const bottomOffset = rect.y + rect.height;
    // below viewport
    if (topOffset > 0) {
        return Math.abs(topOffset) < nearDistance;
    }
    // above viewport
    if (bottomOffset < 0) {
        return Math.abs(bottomOffset) < nearDistance;
    }
    // near viewport
    return true;
}
export function useRowVisibility(ref, { enabled = true, nearDistance = typeof window === 'undefined' ? 0 : window.innerHeight, throttleMs = 375 } = {}) {
    const [isVisible, setIsVisible] = useState(true);
    useEffect(()=>{
        if (!enabled) {
            return;
        }
        const updateVisibility = throttle(()=>setIsVisible(getIsVisibleOrNear(ref.current, nearDistance)), throttleMs, {
            leading: true,
            trailing: true
        });
        updateVisibility();
        window.addEventListener('scroll', updateVisibility, {
            passive: true
        });
        return ()=>window.removeEventListener('scroll', updateVisibility);
    }, [
        enabled,
        nearDistance,
        throttleMs,
        ref
    ]);
    return isVisible;
}
